module.exports = __webpack_public_path__ + "img/step3.51c48822.png";